import * as React from 'react';

export type DMBrProps = React.HTMLAttributes<HTMLBRElement>;

export const DMBr = ({ ...props }: DMBrProps) => {
  return <br {...props} />;
};
DMBr.displayName = 'DMBr';
